import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectFieldLabel: {
		id: 'issue-create.modal.create-form.project-picker.project-field-label',
		defaultMessage: 'Project',
		description: 'Label for project field in issue create form',
	},
	recentProjects: {
		id: 'issue-create.modal.create-form.project-picker.recent-projects',
		defaultMessage: 'Recent Projects',
		description: 'Label for recent projects group in project field',
	},
	allProjects: {
		id: 'issue-create.modal.create-form.project-picker.all-projects',
		defaultMessage: 'All Projects',
		description: 'Label for all projects group in project field',
	},
});
